import { render, staticRenderFns } from "./AlarmClockIcon.vue?vue&type=template&id=3946c5aa&scoped=true"
import script from "./AlarmClockIcon.vue?vue&type=script&lang=js"
export * from "./AlarmClockIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3946c5aa",
  null
  
)

export default component.exports